export default __webpack_public_path__ + "static/media/44.1e6b6692.jpeg";